import Vue from "vue"
import VueCompositionApi from "@vue/composition-api"

Vue.config.performance = process.env.NODE_ENV !== "production"
Vue.config.productionTip = false

Vue.use( VueCompositionApi )
